export const SET_SIGNING_METADATA = 'SET_SIGNING_METADATA';

export const setSigningMetadata = (payload) => {
  return {
    type: SET_SIGNING_METADATA,
    payload: payload,
  };
};
